module.exports = __webpack_public_path__ + "media/fonts/SFProText-Medium-a7e987f5c28ba5aca594efb2389e053a.eot";